module.exports = __webpack_public_path__ + "prod/1.42.2/img/four-screens.ce7bf9a0.png";